const Close = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.37 15.844a1.263 1.263 0 1 0 1.786 1.786L10 11.786l5.844 5.844a1.263 1.263 0 1 0 1.786-1.786L11.786 10l5.844-5.844a1.263 1.263 0 0 0-1.786-1.786L10 8.214 4.156 2.37A1.263 1.263 0 0 0 2.37 4.156L8.214 10 2.37 15.844Z"
    />
  </svg>
);
export default Close;
